import React from "react";
import {List} from "../modules/Samples";

export function SamplesListPage() {
  return (
    <List />
  );
}
